import React, { useEffect, useState } from "react";

import GridContainer from "common/components/Grid/GridContainer.jsx";
import GridItem from "common/components/Grid/GridItem.jsx";
import FormLabel from "@material-ui/core/FormLabel";
import TextField from '@material-ui/core/TextField';

import Checkbox from '@material-ui/core/Checkbox';

import withStyles from "@material-ui/core/styles/withStyles";
import styles from "../../styles.js"
import ChangesDropdownComponent from "./ChangesDropdownComponent.jsx";

const EmailComponent = props => {
  const { classes } = props;

  const mountedRef = useMountedRef();
  const changeOptions = ["Add new", "Replace current", "Other (please describe)"];

  const [isError, setError] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);
  const [changeDropdownValue, setChange] = useState(changeOptions[0]);
  const [toBeReplaced, setReplace] = useState("");
  const [replaceError, setReplaceError] = useState(false);
  const [emailValue, setEmail] = useState("");
  const [isAccountAdmin, setAccountAdmin] = useState(false);
  const [receivesInvoices, setInvoices] = useState(false);
  const [contactsOnly, setContact] = useState(false);
  
  useEffect(() => {
    if(mountedRef.current){
        setError(getEmailErrors())
        props.handleChange("txtField", getFullInfo(), props.iteration, getEmailErrors())
    }
  }, [changeDropdownValue, toBeReplaced, emailValue, isAccountAdmin, receivesInvoices, contactsOnly])

  let getFullInfo = () => {
    let fullInfo = ""
    switch(changeDropdownValue) {
        case "Add new":
            fullInfo = "Add new email address:" + emailValue;
            break;
        case "Replace current":
            fullInfo = "Replace current email " + toBeReplaced + " with new address: " + emailValue;
            break;
        case "Other (please describe)":
            fullInfo = emailValue;
            break;
    }

    fullInfo = isAccountAdmin ? fullInfo + ", This is an Account Admin" : fullInfo;
    fullInfo = receivesInvoices ? fullInfo + ", This email receives invoices" : fullInfo;
    fullInfo = contactsOnly ? fullInfo + ", This is a contacts only account" : fullInfo;

    return fullInfo
  }

  let checkIfBlank = (value) => {
    return value === "" ? true : false
  }

  let getEmailErrors = () => {
      if (checkIfBlank(emailValue)) {
          setErrorMessage("Field cannot be blank")
          return true
      } else if (isRegexError(emailValue)) {
          return true
      }
      if(checkDropdownErrors()){
          return true
      } else return false
  }

  let isRegexError = (value) => {
      let isValid = props.apiRegex.email.regex.test(value)
      if (!isValid) {
          setErrorMessage(props.apiRegex.email.errorMessage)
      } else {
          setErrorMessage("")
      }
      return !isValid
  }

  let checkDropdownErrors = () => {
    let isDropdownError = changeDropdownValue === "Replace current" && toBeReplaced === "" ? true : false

    if (isDropdownError) 
        setReplaceError(true)
    else 
        setReplaceError(false)

    return isDropdownError
  }

  let handleTextChange = (value) => {
    setEmail(value)
  }

  let handleDropdownChange = (changeValue, replaceValue) => {
      setChange(changeValue)
      setReplace(replaceValue)
  }

  let handleCheckboxClick = (value) => {
    switch(value) {
        case "account admin":
            setAccountAdmin(isAccountAdmin ? false : true)
            break;
        case "invoices":
            setInvoices(receivesInvoices ? false : true)
            break;
        case "contact":
            setContact(contactsOnly ? false : true)
            break;
        }
  }

  return (
    <div>
        <ChangesDropdownComponent
            iteration={props.iteration}
            selectedValue={"email"}
            userInfo={props.userInfo}
            selectDefaultValue={props.selectDefaultValue}
            changeOptions={changeOptions}
            handleDropdownChange={handleDropdownChange}
            replaceError={replaceError}
        />
        <GridContainer
          className={classes.containerLine}
          alignItems="center"
        >
          <GridItem xs={6}>
              <FormLabel className={classes.labelHorizontal}>
                  Please type new value
              </FormLabel>
          </GridItem>
          <GridItem xs={6}>
              <TextField
                  required
                  id={"txtId" + props.iteration}
                  error={isError}
                  label="Required"
                  onChange={(event) => {
                          handleTextChange(event.target.value)
                      }
                  }
                  className={classes.txtField}/>
                  {errorMessage}
          </GridItem>
      </GridContainer>
      <GridContainer
            className={classes.containerLine}
            alignItems="center"
        >
            <GridItem xs={6}>
                <FormLabel className={classes.labelHorizontal}>
                    Account admin
                </FormLabel>
            </GridItem>
            <GridItem xs={6}>
                <Checkbox
                    checked={isAccountAdmin}
                    onChange={(event) => {
                            handleCheckboxClick("account admin")
                        }
                    }
                />
            </GridItem>
        </GridContainer>
        <GridContainer
            className={classes.containerLine}
            alignItems="center"
        >
            <GridItem xs={6}>
                <FormLabel className={classes.labelHorizontal}>
                    Receives invoices
                </FormLabel>
            </GridItem>
            <GridItem xs={6}>
                <Checkbox
                    checked={receivesInvoices}
                    onChange={(event) => {
                            handleCheckboxClick("invoices")
                        }
                    }
                />
            </GridItem>
        </GridContainer>
        <GridContainer
            className={classes.containerLine}
            alignItems="center"
        >
            <GridItem xs={6}>
                <FormLabel className={classes.labelHorizontal}>
                    Contact only
                </FormLabel>
            </GridItem>
            <GridItem xs={6}>
                <Checkbox
                    checked={contactsOnly}
                    onChange={(event) => {
                            handleCheckboxClick("contact")
                        }
                    }
                />
            </GridItem>
        </GridContainer>
    </div>
  );
};

export default withStyles(styles)(EmailComponent);

const useMountedRef = () => {
    const mountedRef = React.useRef(false);
  
    React.useEffect(() => {
      setTimeout(() => {
        mountedRef.current = true;
      });
    }, []);
  
    return mountedRef;
  };
